import { toast } from "react-toastify";
import { sendPdfToEmail } from "../services/consultationService";
import jsPDF from "jspdf";
import logoImg from "../Assets/Images/site_logo.png";

export const sendEmailToMe = async (data, profile, consultationSections, headers) => {
    try {
        const doc = new jsPDF();
        const currentDate = new Date().toLocaleDateString();
        const currentTime = new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        doc.setProperties({
            title: "Consultation Summary",
            subject: "DR. Jan AI Consultation",
            author: "DR. Jan AI",
            creator: "DR. Jan AI Platform",
        });
        doc.addImage(logoImg, "PNG", 15, 10, 20, 20);
        doc.setFontSize(20);
        doc.setTextColor(0, 101, 255);
        doc.text("DR. Jan AI Consultation", 105, 20, { align: "center" });
        doc.setDrawColor(0, 101, 255);
        doc.setLineWidth(0.5);
        doc.line(20, 25, 190, 25);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);
        doc.text("Consultation Summary", 20, 35);
        doc.setFontSize(10);
        doc.text(`Date: ${currentDate}`, 20, 45);
        doc.text(`Time: ${currentTime}`, 20, 50);
        doc.text(`Patient: ${profile?.full_name || "Patient"}`, 20, 55);
        if (profile?.age) doc.text(`Age: ${profile?.age}`, 20, 60);
        if (profile?.gender) doc.text(`Gender: ${profile?.gender}`, 20, 65);
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.2);
        doc.line(20, 70, 190, 70);
        let yPos = 80;
        if (consultationSections && consultationSections.length > 0) {
            consultationSections.forEach((section, index) => {
                if (yPos > 240) {
                    doc.addPage();
                    yPos = 20;
                }
                doc.setFontSize(12);
                doc.setTextColor(0, 101, 255);
                doc.text(`${index + 1}. ${section.question}`, 20, yPos);
                yPos += 7;
                doc.setFontSize(10);
                doc.setTextColor(0, 0, 0);
                const answerLines = doc.splitTextToSize(section.answer, 170);
                doc.text(answerLines, 20, yPos);
                yPos += answerLines.length * 5 + 15;
            });
        } else {
            doc.setFontSize(10);
            doc.setTextColor(100, 100, 100);
            doc.text("No consultation data available.", 20, yPos);
        }
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.text(
                "This document is generated by DR. Jan AI Consultation Assistant and is for informational purposes only.",
                105,
                280,
                { align: "center" },
            );
            doc.text(`Page ${i} of ${pageCount}`, 105, 285, { align: "center" });
        }

        // Convert PDF to Blob
        const pdfBlob = doc.output("blob");
        const pdfFile = new File(
            [pdfBlob],
            `consultation_summary_${new Date().toISOString().split("T")[0]}.pdf`,
            { type: "application/pdf" },
        );

        const formData = new FormData();
        formData.append("file", pdfFile);
        if (data) {
            Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
            });
        }

        const responseData = await sendPdfToEmail(formData, headers);
        if (responseData.code === 200 && responseData.status === true) { toast.success(responseData.message) }
    }
    catch (error) {
        if (error.response && error.response.data) {
            const errorMessage = error.response.data.error || "An error occurred";
            toast.error(errorMessage);
        }
        else { toast.error("An error occurred") }
    }
};